import { render, staticRenderFns } from "./menuTree.vue?vue&type=template&id=22534de0&scoped=true"
import script from "./menuTree.vue?vue&type=script&lang=js"
export * from "./menuTree.vue?vue&type=script&lang=js"
import style0 from "./menuTree.vue?vue&type=style&index=0&id=22534de0&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22534de0",
  null
  
)

export default component.exports